import { render, staticRenderFns } from "./DeleteCandidateButton.vue?vue&type=template&id=6e944218&"
import script from "./DeleteCandidateButton.vue?vue&type=script&lang=js&"
export * from "./DeleteCandidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports